module.exports = __webpack_public_path__ + "img/logo-beo.3377517f.svg";